<template>
    <div>
        <div class="card border-0 m-b-10">
            <div class="card-body">
                <h4 class="card-title" v-text="enrolleeDocumentsGet.title"></h4>
                <div class="card-text">
                    <ol>
                        <li v-for="(item,index) in enrolleeDocumentsGet.list" :key="index"
                            v-text="item"></li>
                    </ol>
                    <a :href="enrolleeDocumentsGet.path" class="card-text text-gray"
                       v-text="enrolleeDocumentsGet.download" download></a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: mapGetters(["enrolleeDocumentsGet"]),
    }
</script>